import * as Tooltip from '@radix-ui/react-tooltip'
import { motion } from 'framer-motion'

/**
 * Inline (?) icon with hover/focus tooltip. Use beside any non-obvious UI element.
 *
 * <HelpTooltip>This is what the cap means</HelpTooltip>
 */
export default function HelpTooltip({ children, label, sideOffset = 6, side = 'top' }) {
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-brand-border text-brand-text-muted text-[10px] font-bold hover:border-brand-blue hover:text-brand-blue transition-colors"
          aria-label={label || 'Help'}
        >
          ?
        </button>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content sideOffset={sideOffset} side={side} asChild>
          <motion.div
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.18 }}
            className="bg-brand-text text-white text-xs px-3 py-2 rounded-md max-w-xs shadow-lg leading-relaxed"
          >
            {children}
            <Tooltip.Arrow className="fill-brand-text" />
          </motion.div>
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  )
}
